export default `float s=4., e;
    for(int i=0;i++<7;p.y-=10.)
      p.xz=.8-abs(p.xz),
      p.x < p.z?p=p.zyx:p,
      s*=e=2.5/clamp(dot(p,p),.1,1.2),
      p=abs(p)*e-1.;
    return length(p)/s+.001;
  }`